export default __webpack_public_path__ + "static/media/joconde.771705ce.png";